import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { DELETE_ADMISSION_LEVEL_VACANCIES_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useDeleteAdmissionLevelVacancies = ({ onSuccess, onError }: Input) => {
  const deleteAdmissionLevelVacancies = async (uuid: string) => {
    await axiosClient.delete(DELETE_ADMISSION_LEVEL_VACANCIES_URL(uuid));
  };

  return useCustomMutation(deleteAdmissionLevelVacancies, {
    onSuccess,
    onError,
  });
};
